import LinkButton from "components/common/LinkButton";
import NextPaymentDetails from "interfaces/response/NextPaymentDetails";
import * as routePath from "shared/constants/RoutePathConstants";
import { NextPaymentDetailsType } from "shared/enums/NextPaymentDetailsTypeEnum";
import { getRemainingGracePeriodDays } from "shared/utility/InvoiceHelper";
import { getFullDateFromString } from "shared/utility/DateTimeUtility";
import { useHistory } from "react-router";
import Button from "components/common/controls/Button";

interface Props {
  nextPaymentDetails?: NextPaymentDetails;
}

export default function ActionConsumptionProgressSubscriptionSummary(
  props: Props
) {
  const { nextPaymentDetails } = props;
  const history = useHistory();
  const handleViewOrUpgradePlanClick = () => {
    history.push(routePath.SUBSCRIPTION);
  };

  const ViewInvoicesButton = () => {
    const handleViewInvoiceClick = () => {
      history.push(routePath.INVOICES);
    };
    return <Button text="VIEW INVOICES" onClick={handleViewInvoiceClick} />;
  };

  const SubscriptionSummary = () => {
    if (
      nextPaymentDetails &&
      nextPaymentDetails.date &&
      nextPaymentDetails.type === NextPaymentDetailsType.Active
    ) {
      return (
        <div className="flex flex-wrap gap-x-6 gap-y-2">
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <div>
              {" "}
              Subscription:{" "}
              <span className="text-promDeepMint font-bold">ACTIVE</span>
            </div>
            <div>
              Next payment:{" "}
              <span className="text-promGray2">
                {getFullDateFromString(nextPaymentDetails.date)}
              </span>
            </div>
          </div>
          <div>
            <LinkButton className="mr-4" onClick={handleViewOrUpgradePlanClick}>
              view plan settings
            </LinkButton>
          </div>
        </div>
      );
    } else if (
      nextPaymentDetails &&
      nextPaymentDetails.date &&
      nextPaymentDetails.type === NextPaymentDetailsType.GracePeriod
    ) {
      return (
        <div className="flex gap-x-6 items-center flex-wrap gap-y-2">
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <div>
              Subscription:{" "}
              <span className="text-promRed1 font-bold">UNPAID</span>
            </div>
            <div className="flex gap-x-1">
              <div>Grace period:</div>
              <div className="text-promRed1">
                <span className="font-bold">
                  {getRemainingGracePeriodDays(nextPaymentDetails.date)}
                </span>{" "}
                days remaining
              </div>
            </div>
          </div>
          <div>
            <ViewInvoicesButton />
          </div>
        </div>
      );
    } else if (
      nextPaymentDetails &&
      nextPaymentDetails.type === NextPaymentDetailsType.PaymentDue
    ) {
      return (
        <div className="flex flex-wrap gap-x-6 gap-y-2 items-center">
          <div className="flex flex-wrap gap-y-2 gap-x-6">
            <div>
              Subscription:{" "}
              <span className="text-promRed1 font-bold">PAUSED</span>
            </div>
            <div>
              Cause: <span className="text-promGray2">payment overdue</span>
            </div>
          </div>
          <div>
            <ViewInvoicesButton />
          </div>
        </div>
      );
    }

    return <></>;
  };

  return (
    <div className="text-sm">
      <SubscriptionSummary />
    </div>
  );
}
